export const COLUMNS = [
    { key: "status", label: "", sortable: true, width: "1%" },
    { key: "name", label: "Name", sortable: true, width: "25%" },
    { key: "eventType", label: "Event Type", sortable: true, width: "15%" },
    { key: "url", label: "URL", sortable: false, width: "30%" },
    { key: "createdAt", label: "Created", sortable: true, width: "15%" },
    { key: "actions", label: "", sortable: false, width: "5%" }
];
